/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import { Text, View } from '@az/starc-ui';
import NextImage from '@/components/NextImage';
import styles from './styles.module.scss';

const labelMap = {
  originallyPostedOn: 'label_reviews_originallyPostedOn',
};

type SyndicatedReviewBadgeProps = {
  name: string | null;
  logo: string | null;
};

export const SyndicatedReviewBadge = ({ name, logo }: SyndicatedReviewBadgeProps) => {
  const labels = useLabels(labelMap);

  if (!name || !logo) {
    return null;
  }

  return (
    <View
      className={styles.syndicatedReviewBadge}
      attributes={{ 'data-testid': 'syndicatedReviewBadge' }}
    >
      <NextImage
        width={42}
        height={42}
        src={logo}
        className={styles.symdicatedReviewImage}
        alt={name}
      />

      <Text maxLines={2} as="p" variant="main-body">
        {`${labels.originallyPostedOn} ${name}`}
      </Text>
    </View>
  );
};
